import { Box } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import OperatingYearRow from '@Router/NatureOfBusiness/Components/IncomeStructure/OperatingYearRow';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { getBuddhistYear } from '@Utils/datetime';
import ProductIncomeAddButton from './ProductIncomeActions/ProductIncomeAddButton';
import ProductIncomeExtendedForm from './ProductIncomeExtendedForm';
import ProductIncomeOtherForm from './ProductIncomeOtherForm';
import ProductIncomeTotalForm from './ProductIncomeTotalForm';
import ProductIncomeTotalPct from './ProductIncomeTotalPct';
import ProductIncomeOtherPct from './ProductIncomeOtherPct';
import ProductIncomeExtendedPct from './ProductIncomeExtendedPct';
import UploadImageFormFields from '@Containers/UploadImageFormFields';
import { useNatureOfBusinessForm } from '../../NatureOfBusinessFormProvider';
import { IIncomeStructureFormValues } from '../../NatureOfBusinessFormProvider/types';

const ProductIncomeForm = () => {
  const { progressData } = useProgressBar();
  const { watch } = useNatureOfBusinessForm();

  const incomeStructure = watch(
    'incomeStructure'
  ) as IIncomeStructureFormValues;
  const { isCompletedTh = false, isCompletedEn = false } =
    incomeStructure?.completedSection ?? {};

  const startOperatingYear =
    progressData?.report.startOperatingYear ?? getBuddhistYear();

  return (
    <Box mt={2}>
      <OperatingYearRow startOperatingYear={startOperatingYear} gap={1} />
      <ProductIncomeTotalForm />
      <ProductIncomeExtendedForm />
      <ProductIncomeOtherForm />
      <ProductIncomeAddButton />
      <Box mt={6} />
      <ProductIncomeTotalPct />
      <ProductIncomeExtendedPct />
      <ProductIncomeOtherPct />
      <Flex mt={6} flexDirection={'column'}>
        <UploadImageFormFields
          title={'รูปภาพโครงสร้างรายได้ของสายผลิตภัณฑ์หรือกลุ่มธุรกิจ'}
          name={`incomeStructure`}
          disabledTh={isCompletedTh}
          disabledEn={isCompletedEn}
        />
      </Flex>
    </Box>
  );
};

export default ProductIncomeForm;
